module.exports = __webpack_public_path__ + "static/media/Illustration4.af975bdf.png";